<!--URL情報画面-->
<template>
  <div class="informationurl">
    <v-card class="bg-primary text-light text-left">URL情報</v-card>
  </div>
</template>

<script>
import store from "../store";
export default {
  name: "Informationurl",
  computed: {
    getname() {
      return store.getters.name;
    },
  },
};
</script>
